import React, { Component } from "react";
import logo from "../images/logo.svg";
import "./banner.scss";
import YouTube from "react-youtube";
import menuImg from "../images/menu.png"
import Aos from "aos";
import "aos/dist/aos.css";
import firestore from "../services/firebase";
import tr from "../images/tr.png"
import us from "../images/us.png"

export default class Banner extends Component {
  constructor(props) {
    super(props);
    this.state={
        lan:1,
        menu:"banner-header-ul",
        name: "",
        mail: "",
        number: "",
        message: "",
    }  
}

toggleSidenav() {
  var css = (this.state.menu === "banner-header-ul") ? "banner-header-open" : "banner-header-ul";
  this.setState({"menu":css});
}
changeValue=(event)=>{
  event.preventDefault()
  this.setState({[event.target.name] : event.target.value});
}
sendForm=()=>{
  
  firestore.firestore().collection('mesajlar')
    .add({
      isim: this.state.name,
      mail: this.state.mail,
      numara: this.state.number,
      mesaj: this.state.message
    })
    this.setState({"name":""})
    this.setState({"mail":""})
    this.setState({"number":""})
    this.setState({"message":""})
}
  _onReady(event) {
    event.target.pauseVideo();
  }
  render() {
     Aos.init({duration: 2000});
    const opts = {
      height: "390",
      width: "640",
      playerVars: {
        rel: 0,
        autoplay: 0,
      },
    };
    return (
      <div>
        <div className="banner">
          <header className={"banner-header"}>
            <a href="#" className="banner-header-logo">
              prome
            </a>
            <img alt="" src={menuImg} className="hamburger" onClick={()=>this.toggleSidenav()}></img>
            <ul className={this.state.menu}>
              <li>
                <a href="#about" onClick={()=>{this.setState({"menu":"banner-header-ul"});}}>{
                  this.state.lan === 1 ? "HAKKIMIZDA" : "ABOUT US"
                }</a>                
              </li>
              <li>
                <a href="#project" onClick={()=>{this.setState({"menu":"banner-header-ul"});}}>{
                  this.state.lan === 1 ? "PROJELERİMİZ" : "PROJECTS"
                }</a>                
              </li>
              <li>
                <a href="#ref" onClick={()=>{this.setState({"menu":"banner-header-ul"});}}>{
                  this.state.lan === 1 ? "REFERANSLARIMIZ" : "REFERENCES"
                }</a>                
              </li>
              <li>
                <a href="#contact" onClick={()=>{this.setState({"menu":"banner-header-ul"});}}>{
                  this.state.lan === 1 ? "BİZE ULAŞIN" : "CONTACT US"
                }</a>                
              </li>
              <li>
              <img alt="" src={tr} onClick={()=>{
                this.setState({"lan":1})
              }}></img>               
              </li>
              <li>
              <img alt="" src={us} onClick={()=>{
                this.setState({"lan":2})
              }}></img>           
              </li>
            </ul>
          </header>
          <img src="https://live.staticflickr.com/65535/50209205423_40203b201b_z.jpg" className="banner-bck"></img>
          <div className="banner-content">
          <img data-aos="zoom-in" src={logo} alt=""></img>  
          <p data-aos="zoom-in">{this.state.lan===1 ? "PROJE, MAKİNE, ELEKTRİK" : "PROJECT, MACHINE, ELECTRIC"}</p>
          </div>
          
           
        </div>
        <section className="about" id="about">
          <div className="about-contentBx">
            <h2 data-aos="fade-right" className="about-contentBx-heading">{
                  this.state.lan === 1 ? "HAKKIMIZDA" : "ABOUT US"
                }</h2>
            <p data-aos="fade-right" className="about-contentBx-text">
            {
                  this.state.lan === 1 ? "Mekanik ve elektrik hizmetleri vererek sürdürdüğü faaliyetlerini, uzun yıllara varan tecrübelerin kurumsallaşma fikri ile pekiştiren Prome Mühendislik, sektörde lider pozisyona erişme hedefi; projeden, tesisat ve montaja kadar her aşamada kalite, hız, kesin çözüm prensibi ve müşteri memnuniyeti ilkesi ile çalışmalarına tutkuyla devam etmektedir." : "Prome Mühendislik, which reinforces its activities by providing mechanical and electrical services with the idea of institutionalization of many years of experience, continues to work with passion with the principle of quality, speed, absolute solution principle and customer satisfaction at every stage from project to installation and Assembly."
                }
              <br></br>
              <br></br>
              {
                  this.state.lan === 1 ? "Prome Mühendislik, yangın ihbar sistemi, cctv tesisatı, acil anons ve seslendirme tesisatı, paratoner, topraklama tesisatı, data tesisatı, çevre aydınlatması, kablo tava hizmetleri, busbar tesisatları, otomasyon, AG/ OG sistemleri ve iklimlendirme alanlarında konfor ve verimliliği insan yaşamına sunma gayesi ile çalışmalarını sürdürmekte olup, iş süreçlerini gerekli tüm yönetmeliklere uygun olarak yönetebilme tecrübesine ve tüm işlerinde kusursuzluk arayışında olma özverisine sahiptir." 
                  : 
                  "Prome Engineering aims to offer comfort and efficiency to human life in the areas of fire warning system, cctv installation, emergency announcement and sounding installation, lightning rod, grounding installation, data installation, environmental lighting, cable pan services, busbar installations, automation, AG / OG systems and air conditioning. continues to work with, has the experience of managing business processes in accordance with all necessary regulations and has the devotion to seek perfection in all works."
                }
                
            </p>
          </div>
          <div className="about-imgBx" >
            <div data-aos="fade-up">
            <YouTube
              className="about-imgBx-video"
              videoId={
                this.state.lan === 1 ? "gaPLMz1saV4" : "ct5ZxlJkZ3s"
              }
              opts={opts}
              onReady={this._onReady}
            />
            </div>
           
          </div>
        </section>
        <section className="about">
          <div className="about-imgBx">
            <img data-aos="fade-right" className="about-imgBx-video" src="https://live.staticflickr.com/65535/50209206253_c6d1065ce5_b.jpg"></img>
          </div>
          <div className="about-contentBx">
            <p  data-aos="fade-up" className="about-contentBx-text">
            {
                  this.state.lan === 1 ? "Firmamız ayrıca; Mekanik Tesisatı, Sıhhi Tesisat, Isıtma Tesisatı, Havalandırma Tesisatı, Yangın Tesisatı, Klima Tesisatı, Uygulama as-built ruhsat projelendirilmesi, Enerji Kimlik Belgesi alınması, Akustik Projelerinin yapılması hizmetleri ile de müşterilerinin tüm projelendirme, üretim ve montaj taleplerine cevap vermektedir." 
                  : 
                  "Our company also responds to all customer requests for project design, production and assembly with its services of mechanical fittings, sanitary fittings, heating system installments, ventilation installation, air conditioning unit installation, project design of as-built license applications, obtaining Energy Identity Certificates and the design of acoustic projects."
                }
              <br></br>
              <br></br>
              {
                  this.state.lan === 1 ? "Prome Mühendislik, konutlar, oteller, hastaneler, fabrikalar, okullar, avmler ve mağazalar gibi yapım süreci hassasiyet gerektiren binaların elektrik ve mekanik tesisat hizmetinde, kaliteli malzeme, yüksek teknoloji kullanımı ve estetik anlayışı prensiplerinden ödün vermeden çalışmalarını sürdürmekte; alanında uzman mühendis, tekniker ve teknik personel kadrosu ile en güncel teknolojik gelişmelere uyum sağlayabilme yeteneğini birleştirerek müşterilerine hizmet vermektedir." : "While servicing buildings requiring precision such as residences, hotels, hospitals, factories, schools, shopping malls and stores with electrical and mechanical fittings, Prome Engineering does not compromise on the principles of the use of quality materials, advanced technology and aesthetics. It serves its customers by combining its expert engineers, technicians and technical personnel with its ability to adapt to the most up-to-date technological developments"
                }
            </p>
          </div>
        </section>
        <section className="about">
          <div className="about-contentBx">
            <p  data-aos="fade-right" className="about-contentBx-text">
            {
                  this.state.lan === 1 ? "İş sağlığının ve işçi güvenliğinin birincil önem taşıdığı ve uluslararası standartlara uygun koşulların sağlandığı şantiyelerinde; çalışma detaylarının çokça kez kontrol edilerek irdelenmesi ile oluşan güvenli iş teslimi konusundaki profesyonel tavrı, projeden teslimata kadar görev alan tüm Prome ekibinin müşterilerine karşı birincil sorumluluğudur." : "In work sites where occupational health and worker safety is of primary importance and conditions complying with international standards are provided; The professional attitude of secure work delivery, which is formed by checking and examining the details of the work multiple times, is the  primary responsibility of the Prome team, who takes charge from the project to the delivery."
                }
              <br></br>
              <br></br>
              {
                  this.state.lan === 1 ? "Uzmanlık, kalite ve çevreye duyarlılık konusundaki kararlılığını her daim üretken ve güvenilir şirket bilinirliği ile perçinleyen Prome, yenilikçi yaklaşımlarını projelere yansıtarak imza attığı büyük projelerle de sektörde kendini konumlandırmakta ve gücünü kanıtlamaktadır." : "Our company, which has always strengthened its commitment to expertise, quality and environmental awareness with its productive and reliable company awareness, reflects its innovative approaches to projects and also positions itself in the sector with its big projects and proves its strength."
                }
              <br></br>
              <br></br>
              {
                  this.state.lan === 1 ? "Uygun fiyat politikası ve zamanında iş teslimini bir şirket ideali haline getirerek kurulduğu günden bugüne, birçok firma, kurum ve kuruluşa verdiği hizmetlerini hassasiyetle sürdüren Prome Mühendislik, sürekli güçlenen gelişim grafiği ve hızlı büyüme trendi ile sektöre güç katarak müşterilerine hizmet vermeye devam etmektedir." : "With its affordable price policy and timely delivery of business, Prome Mühendislik, which has been continuing its services to many companies, institutions and organizations with precision since its foundation, continues to serve its customers by adding strength to the sector with its ever-growing development graphic and rapid growth trend."
                }
              
            </p>
          </div>
          <div className="about-imgBx">
            <img  data-aos="fade-up" className="about-imgBx-video" src="https://live.staticflickr.com/65535/50210006197_33d301e34f_b.jpg"></img>
          </div>
        </section>
        <section className="services" id="project">
            <h2  data-aos="fade-down" className="about-contentBx-heading">{
                  this.state.lan === 1 ? "ÇAMSAN PARK AVYM VE REZİDANS PROJESİ" : "ÇAMSAN PARK SHOPPING MALL AND RESIDENCE PROJECT"
                }</h2>
            <p  data-aos="fade-down" className="about-contentBx-text"><br></br><br></br>
            {
                  this.state.lan === 1 ? "Çamsan Park Sancaktepe Alışveriş Merkezi; farklı mimarisi, lokasyonu, güçlü marka karmasıyla sadece Sancaktepe’nin değil, bölgenin favori çekim ve yaşam alanlarından biri olacak." : "Çamsan Park Sancaktepe Shopping Center; With its different architecture, location and strong brand mix, it will become one of the favorite living spaces of not only Sancaktepe but the region."
                }</p>
            <div className="services-container">
                <div data-aos="zoom-out" className="services-container-serviceBx">
                    
                        <img className="services-container-serviceBx-img" src="https://live.staticflickr.com/65535/50210005112_07e7c48073_b.jpg" alt=""></img>
                    
                </div>
                <div data-aos="zoom-out" className="services-container-serviceBx">
                    
                        <img className="services-container-serviceBx-img" src="https://live.staticflickr.com/65535/50209728591_0ce9bd4c97_b.jpg" alt=""></img>
                    
                </div>
                <div data-aos="zoom-out" className="services-container-serviceBx">
                        <img className="services-container-serviceBx-img" src="https://live.staticflickr.com/65535/50210004252_928cf0ef5c_b.jpg" alt=""></img>
                </div>
            </div>
        </section>
        <section className="testimonials" id="ref">
            <h2 data-aos="fade-up" className="about-contentBx-heading">{
                  this.state.lan === 1 ? "REFERANSLARIMIZ" : "REFERENCES"
                }</h2>
            <div className="testimonials-container">
                <div data-aos="fade-up" className="testimonials-container-contentBx">
                    <img className="testimonials-container-contentBx-img" src="https://live.staticflickr.com/65535/50209204723_2bd5f45d59_z.jpg" alt=""></img>
                </div>
                <div data-aos="fade-up" className="testimonials-container-contentBx">
                    <img className="testimonials-container-contentBx-img" src="https://live.staticflickr.com/65535/50213476601_5d519a295b_z.jpg" alt=""></img>
                </div>
            </div>
        </section>
        <section className="contact" id="contact">
        <h2 data-aos="zoom-in" className="about-contentBx-heading">{
                  this.state.lan === 1 ? "BİZE ULAŞIN" : "CONTACT US"
                }</h2>
        <p data-aos="zoom-in" className="about-contentBx-text"><br></br>info@promemuhendislik.com</p>
        <p data-aos="zoom-in" className="about-contentBx-text"><br></br>+90 (507) 530 07 98</p>
        <p data-aos="zoom-in" className="about-contentBx-text"><br></br>İçmeler Mah. Ankara Cad. No:28 Tuzla / İstanbul / Türkiye</p>
        </section>
        <section className="about">
          <div className="about-contentBx redbg">
            <div className="about-contentBx-form">
                <div data-aos="fade-right" className="about-contentBx-form-inputBx">
                    <input className="contact-form-inbutBx-input" type="name" id="name" name="name" placeholder={
                  this.state.lan === 1 ? "Tam Adınız" : "Full Name"
                } value={this.state.name} onChange={this.changeValue}></input>
                </div>
                <div data-aos="fade-right" className="about-contentBx-form-inputBx">
                    <input className="contact-form-inbutBx-input" type="name" name="mail" placeholder={
                  this.state.lan === 1 ? "Mail Adresiniz" : "Email Adress"
                } value={this.state.mail} onChange={this.changeValue}></input>
                </div>
                <div data-aos="fade-right" className="about-contentBx-form-inputBx">
                    <input className="contact-form-inbutBx-input" type="name" name="number" placeholder={
                  this.state.lan === 1 ? "Telefon Numaranız" : "Phone Number"
                } value={this.state.number} onChange={this.changeValue}></input>
                </div>
                <div data-aos="fade-right" className="about-contentBx-form-inputBx">
                    <textarea  className="contact-form-inbutBx-textarea" name="message" placeholder={
                  this.state.lan === 1 ? "Mesajınızı Yazınız" : "Your Message"
                } value={this.state.message} onChange={this.changeValue}></textarea>
                </div>
                <div data-aos="fade-right" className="about-contentBx-form-inputBx">
                    <input className="contact-form-inbutBx-input" type="submit" name="" value={
                  this.state.lan === 1 ? "Gönder" : "Submit"
                } onClick={this.sendForm}></input>
                </div>
            </div>
          </div>
          <div className="about-imgBx imgBx2">
          </div>
        </section>
      </div>
    );
  }
}